import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dashboard-active",
  "use": "icon-dashboard-active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dashboard-active\">\n<circle cx=\"4.75\" cy=\"4.75\" r=\"3.75\" fill=\"currentColor\" />\n<circle cx=\"15.25\" cy=\"4.75\" r=\"3.75\" fill=\"currentColor\" />\n<circle cx=\"4.75\" cy=\"15.25\" r=\"3.75\" fill=\"currentColor\" />\n<circle cx=\"15.25\" cy=\"15.25\" r=\"3.75\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol